import React, { useEffect } from "react";
import CourseProgressCard from "components/widget/CourseProgressCard";
import { connect } from "react-redux";
import { 
	getTrainingClassParticipantList, 
} from "../../../../redux/trainingclass/trainingClassState";
import dayjs from "dayjs";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideGraduationCap } from "lucide-react";




const TrainingCoursesTable = ({
	recordList, 
	pagination, 
	doSearch, 
}) => {

useEffect(() => {
doSearch({ paginate: pagination?.per_page});
}, [doSearch, pagination?.per_page]);

const formatSchedule = (from, to) => {
		if (!from || !to) return "No schedule available";
		return `${dayjs(from).format("MMM DD, YYYY")} → ${dayjs(to).format("MMM DD, YYYY")}`;
	};

return (
		<HeaderComponent
			title="My Courses"
			description="Your enrolled courses and training programs"
			labelIcon={<LucideGraduationCap size={20}/>}
			cardBorder="border"
			

		>
				{recordList && recordList.length > 0 ? (
					recordList.map((item) => (
					<CourseProgressCard
						key={item.tcp_id}
						title={item.training_class?.tcl_title}
						date={formatSchedule(item.training_class?.tcl_schedule_date_from, item.training_class?.tcl_schedule_date_to)}
						percent={item.participant_progress}
						showProgress={item.participant_progress > 0}
						recordId={item.training_class?.tcl_id}
					/>
				))
					) : (
						<p className="text-gray-500 text-center col-span-full">
							No available classes found.
						</p>
					)}   
		</HeaderComponent>
		
  );
};

const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassParticipantList?.items,
	pagination: state.trainingClass.trainingClassParticipantList?.pagination,
	filters: state.trainingClass.trainingClassParticipantList?.filters,
	requesting: state.trainingClass.trainingClassParticipantList?.requesting,
	error: state.trainingClass.trainingClassParticipantList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassParticipantList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCoursesTable);
